import { Form, FormProps } from 'antd'

import { resetPasswordFormFields } from 'modules/AccessManage/components/ResetPassword/resetPasswordFormFields'
import { useUser } from 'modules/AccessManage/hooks/useUser'
import { ResetPasswordFormState } from 'modules/AccessManage/types'

import FormItems from 'shared/ui/Form/FormItems'
import ModalWindowLayout from 'shared/ui/ModalWindowLayout'

interface Props {
  userId?: string
}
const ResetPassword = ({ userId }: Props) => {
  const [form] = Form.useForm<ResetPasswordFormState>()

  const { handleChangePassword, isResetPasswordLoading } = useUser({
    userId,
  })

  const onFinish: FormProps<ResetPasswordFormState>['onFinish'] = (data) => {
    if (data.new_password !== data.new_password_verify) {
      form.setFields([
        {
          name: 'new_password_verify',
          errors: ['Пароли не совпадают'],
        },
        {
          name: 'new_password',
          errors: ['Пароли не совпадают'],
        },
      ])

      return
    }
    handleChangePassword(data)
  }
  return (
    <Form
      onFinish={onFinish}
      form={form}
    >
      <ModalWindowLayout
        title="Сбросить пароль"
        submit="Сохранить"
        submitClassname="w-[115px]"
        isLoading={isResetPasswordLoading}
      >
        <FormItems items={resetPasswordFormFields} />
      </ModalWindowLayout>
    </Form>
  )
}

export default ResetPassword
